import { useCallback, useEffect, useMemo, useState } from 'react'
import {
  SMALL_MOBILE_BREAKPOINT,
  MOBILE_BREAKPOINT,
  SMALL_TABLET_BREAKPOINT,
  TABLET_BREAKPOINT,
} from 'constants/screen'

export const BREAKPOINTS_KEYS = {
  MOBILE: 0,
  TABLET: 1,
  DESKTOP: 4,
}

const BREAKPOINTS_VALUES = [MOBILE_BREAKPOINT, TABLET_BREAKPOINT]

export const EXPANDED_BREAKPOINTS_KEYS = {
  SMALL_MOBILE: 0,
  MOBILE: 1,
  SMALL_TABLET: 2,
  TABLET: 3,
  DESKTOP: 4,
}

const EXPANDED_BREAKPOINTS_VALUES = [
  SMALL_MOBILE_BREAKPOINT,
  MOBILE_BREAKPOINT,
  SMALL_TABLET_BREAKPOINT,
  TABLET_BREAKPOINT,
]

export const useDetectScreen = (isExpanded = false, isOnlyClient = false) => {
  const isMobileDevice = useMemo(
    () =>
      /Mobi|Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(
        navigator.userAgent
      ),
    []
  )
  const detectScreen = useCallback(() => {
    const breakpoints = isExpanded
      ? EXPANDED_BREAKPOINTS_VALUES
      : BREAKPOINTS_VALUES

    const index = breakpoints.findIndex(
      (value) => window.matchMedia(`(max-width: ${value}px)`).matches
    )

    return index >= 0 ? index : BREAKPOINTS_KEYS.DESKTOP
  }, [isExpanded])

  const initialValue = useMemo(() => {
    if (isOnlyClient) {
      return detectScreen()
    }

    if (isExpanded) {
      return isMobileDevice
        ? EXPANDED_BREAKPOINTS_KEYS.SMALL_MOBILE
        : EXPANDED_BREAKPOINTS_KEYS.DESKTOP
    }

    return isMobileDevice ? BREAKPOINTS_KEYS.MOBILE : BREAKPOINTS_KEYS.DESKTOP
  }, [detectScreen, isOnlyClient])
  const [detected, setDetected] = useState(initialValue)

  useEffect(() => {
    const updateScreens = () => {
      setDetected(detectScreen())
    }

    updateScreens()

    window.addEventListener('resize', updateScreens)

    return () => {
      window.removeEventListener('resize', updateScreens)
    }
  }, [detectScreen])

  return detected
}
